import React from "react";
import { motion } from "framer-motion";
import { RiHomeLine } from "react-icons/ri";

export default function MessageSuccess() {
  return (
    <motion.div 
      className="min-h-screen bg-linear-to-b from-gray-100 via-green-100 to-green-700 flex flex-col"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <main className="flex flex-col items-center mx-6 md:mx-auto">
        {/* Animated emoji celebration */}
        <motion.div 
          className="relative bg-black size-25 rounded-full mt-16 mb-6"
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ 
            delay: 0.2, 
            duration: 0.6, 
            type: "spring", 
            stiffness: 200 
          }}
        >
          <motion.p 
            className="absolute -top-8 left-8 text-8xl"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ 
              delay: 0.5, 
              duration: 0.4,
              type: "spring",
              stiffness: 300
            }}
          >
            🎉
          </motion.p>
        </motion.div>

        {/* Success message text */}
        <motion.div 
          className="text-center mt-8 mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <p>Message sent!</p>
          <p className="mt-4 text-lg">
            Thank you for reaching out! We've received your message
            <br className="hidden md:block" /> and our team will get back to you
            within 24 hours.
          </p>
        </motion.div>

        {/* Message summary card */}
        <motion.div 
          className="bg-white rounded-2xl mt-4 mb-6 flex flex-col gap-4 px-4 py-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
        >
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.7, duration: 0.4 }}
          >
            <h3 className="font-bold">Reference Number</h3>
            <p>#21FNDFLFE</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.8, duration: 0.4 }}
          >
            <h3 className="font-bold">Date</h3>
            <p>12/06/2025</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.9, duration: 0.4 }}
          >
            <h3 className="font-bold">Expected Response</h3>
            <p>Within 24 hours</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.0, duration: 0.4 }}
          >
            <p>
              A confirmation email has been sent to your email
              <br className="hidden md:block" />
              address with all the details.
            </p>
          </motion.div>
        </motion.div>

        {/* Back To Home Button */}
        <motion.div 
          className="mt-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.5 }}
        >
          <motion.button 
            className="flex gap-2 text-white bg-black px-6 text-md items-center font-bold py-2 rounded-3xl mb-8"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <RiHomeLine size={15} />
            <span>Back To Home</span>
          </motion.button>
        </motion.div>
      </main>

      {/* Footer */}
      <motion.footer 
        className="text-center mt-auto pb-8 text-white text-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.5 }}
      >
        <p>Copyright © 2025 AADA. All rights reserved.</p>
      </motion.footer>
    </motion.div>
  );
}